import React, {useMemo} from 'react';
import {Control, useFormContext, useWatch} from 'react-hook-form';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import AttachmentsPreviews from '@src/components/Chat/AttachmentsPreviews/AttachmentsPreviews';
import MessageReceiver from '@src/components/Chat/MessageReceiver/MessageReceiver';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import app from '@src/helpers/app';

export function StatusCommentField(props: {
    containerPath: string,
    placeholder?: string,
    isDisabled?: boolean,
    control: Control<IOrderModel>,
    isReadonly?: boolean,
    size?: 'sm',
}) {
    const {containerPath, isDisabled, isReadonly, size} = props;
    const valueContainer = useWatch({control: props.control, name: containerPath});
    const {message, attachments = []} = valueContainer ?? {};

    const {setValue, formState: {errors}} = useFormContext();
    const errorBag = app('dot-accessor').get(errors, containerPath, null);

    type ReceiverProps = Required<React.ComponentProps<typeof MessageReceiver>>;
    type PreviewerProps = Required<React.ComponentProps<typeof AttachmentsPreviews>>;
    const [setMessage, onDrop, onDelete] = useMemo(() => {
        const setMessage: ReceiverProps['onInput'] = (message) => {
            setValue(`${containerPath}.message`, message);
        };

        const onDrop: ReceiverProps['onDrop'] = (files) => {
            setValue(`${containerPath}.attachments`, [...attachments, ...files]);
        };

        const onDelete: PreviewerProps['onDelete'] = (index) => {
            attachments.splice(index, 1);

            setValue(`${containerPath}.attachments`, [...attachments]);
        };

        return [setMessage, onDrop, onDelete];
    }, [attachments, containerPath, setValue]);

    return <>
        <MessageReceiver
                size={size}
                onInput={setMessage}
                onDrop={onDrop}
                value={message}
                isInvalid={errorBag?.message || errorBag?.attachments}
                isDisabled={isDisabled || isReadonly}
                placeholder={props.placeholder ?? 'OrderForm.products.enter_reason'}
                filesPreviewSlot={
                    <AttachmentsPreviews attachment={attachments} onDelete={onDelete}/>
                }
        />

        <FormErrorMessage fieldName={`${containerPath}.message`}/>
        <FormErrorMessage fieldName={`${containerPath}.attachments`}/>
    </>;
}
